import filters from 'assets/core/js/page/search/base/filters'
import searchMobileActions from 'assets/core/js/page/search/base/search-mobile-actions'
import searchMobileRecap from 'assets/core/js/page/search/base/search-mobile-recap'
import searchSelectedFilters from 'assets/core/js/page/search/base/selected-filters'

export default (): void => {
  filters()
  searchMobileRecap()
  searchMobileActions()
  searchSelectedFilters()
}
